(() => {
  'use strict';

  const cfg = window.APTheme || {};
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];
  const rootRoute = (path) => `${(cfg.root || '/').replace(/\/?$/, '/')}${String(path).replace(/^\//, '')}`;
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: cfg.currency || 'EUR' }).format((Number(cents) || 0) / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  let toastTimer;
  function toast(message) {
    const el = qs('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2400);
  }

  function lockBody(locked) { document.body.classList.toggle('is-locked', locked); }

  function openCartDrawer() {
    const drawer = qs('[data-cart-drawer]');
    const overlay = qs('[data-drawer-overlay]');
    if (!drawer) return;
    overlay?.removeAttribute('hidden');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.scrollTop = 0;
    lockBody(true);
    setTimeout(() => qs('[data-cart-close]', drawer)?.focus(), 30);
  }
  function closeCartDrawer() {
    const drawer = qs('[data-cart-drawer]');
    const overlay = qs('[data-drawer-overlay]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay?.setAttribute('hidden', '');
    lockBody(false);
  }
  function openMobileMenu() {
    const menu = qs('[data-mobile-menu]');
    const overlay = qs('[data-mobile-menu-overlay]');
    const trigger = qs('[data-mobile-menu-open]');
    if (!menu) return;
    overlay?.removeAttribute('hidden');
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    trigger?.setAttribute('aria-expanded', 'true');
    lockBody(true);
    setTimeout(() => qs('[data-mobile-menu-close]', menu)?.focus(), 30);
  }
  function closeMobileMenu() {
    const menu = qs('[data-mobile-menu]');
    const overlay = qs('[data-mobile-menu-overlay]');
    const trigger = qs('[data-mobile-menu-open]');
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    trigger?.setAttribute('aria-expanded', 'false');
    overlay?.setAttribute('hidden', '');
    lockBody(false);
  }

  async function cartAdd(items) {
    const response = await fetch(rootRoute('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!response.ok) {
      let data = {};
      try { data = await response.json(); } catch (_) {}
      throw new Error(data.description || data.message || cfg.strings?.addError || 'No se pudo añadir');
    }
    return response.json();
  }

  async function cartChange(key, quantity) {
    const response = await fetch(rootRoute('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('No se pudo actualizar el carrito');
    return response.json();
  }

  async function getCart() {
    const response = await fetch(rootRoute('cart.js'), { headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error('No se pudo leer el carrito');
    return response.json();
  }

  function isServiceLine(item) {
    return item?.properties && String(item.properties._ap_service) === 'true';
  }

  function updateCartCount(cart) {
    qsa('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    qsa('[data-cart-open]').forEach(el => el.setAttribute('aria-label', `Abrir carrito, ${cart.item_count} productos`));
    qsa('[data-cart-products-heading]').forEach(el => el.toggleAttribute('hidden', cart.item_count === 0));
  }

  function cartLineMarkup(item) {
    const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${escapeHtml(item.variant_title)}</p>` : '';
    return `<article class="cart-line" data-line-key="${escapeHtml(item.key)}">
      <a href="${escapeHtml(item.url)}" class="cart-line__image">${image}</a>
      <div class="cart-line__content">
        <a href="${escapeHtml(item.url)}" class="cart-line__title">${escapeHtml(item.product_title)}</a>
        ${variant}
        <div class="cart-line__bottom">
          <div class="quantity" aria-label="Cantidad de ${escapeHtml(item.product_title)}">
            <button type="button" data-qty-change="-1" data-line-key="${escapeHtml(item.key)}" aria-label="Reducir cantidad">−</button>
            <span data-line-qty>${item.quantity}</span>
            <button type="button" data-qty-change="1" data-line-key="${escapeHtml(item.key)}" aria-label="Aumentar cantidad">+</button>
          </div>
          <strong>${money(item.final_line_price)}</strong>
        </div>
      </div>
      <button type="button" class="cart-line__remove" data-line-remove data-line-key="${escapeHtml(item.key)}" aria-label="Eliminar ${escapeHtml(item.product_title)}">×</button>
    </article>`;
  }

  function updateServiceCards(cart) {
    qsa('[data-service-card]').forEach(card => {
      const variantId = Number(card.dataset.serviceVariant);
      const line = cart.items.find(item => Number(item.variant_id) === variantId && isServiceLine(item));
      const button = qs('[data-service-toggle]', card);
      card.dataset.serviceKey = line?.key || '';
      card.classList.toggle('is-selected', !!line);
      if (button) {
        const activeLabel = button.dataset.labelActive || 'Activado ✓';
        const inactiveLabel = button.dataset.labelInactive || 'Activar';
        const label = line ? activeLabel : inactiveLabel;
        button.classList.toggle('is-active', !!line);
        button.setAttribute('aria-pressed', line ? 'true' : 'false');
        const textEl = qs('.service-toggle__text', button);
        if (textEl) textEl.textContent = label;
      }
      const hint = qs('.service-card__hint', card);
      if (hint) hint.textContent = line ? 'Pulsa para quitarlo del pedido' : 'Pulsa para añadirlo al pedido';
    });
  }

  function updateRewards(cart) {
    const spend = Number(cart.items_subtotal_price || 0);
    const freeGoal = cfg.freeShippingEnabled ? Number(cfg.freeShippingThreshold || 0) : 0;
    const rewards = (cfg.rewards || []).filter(r => Number(r.amount) > 0).sort((a, b) => Number(a.amount) - Number(b.amount));
    const goals = [];
    if (freeGoal > 0) goals.push({ amount: freeGoal, text: 'Envío gratis', icon: '🚚', type: 'shipping' });
    rewards.forEach(r => goals.push({ ...r, type: 'reward' }));
    goals.sort((a, b) => Number(a.amount) - Number(b.amount));
    const maxGoal = Math.max(1, ...goals.map(g => Number(g.amount)));
    const progress = Math.min(100, (spend / maxGoal) * 100);

    qsa('[data-cart-progress-bar]').forEach(el => el.style.width = `${progress}%`);
    qsa('[data-cart-milestones]').forEach(el => {
      el.innerHTML = goals.map(g => `<span class="${spend >= g.amount ? 'is-reached' : ''}">${escapeHtml(g.icon || '★')} ${money(g.amount)}</span>`).join('');
    });

    const next = goals.find(g => spend < Number(g.amount));
    let message = '';
    if (next) {
      const missing = Math.max(0, Number(next.amount) - spend);
      if (next.type === 'shipping') message = `Te faltan ${money(missing)} para conseguir envío gratis`;
      else message = `Te faltan ${money(missing)} para conseguir ${escapeHtml(next.text || 'la siguiente recompensa')}`;
    } else if (goals.length) {
      const last = goals[goals.length - 1];
      message = last.type === 'shipping' ? '🚚 Envío gratis: meta alcanzada' : `${escapeHtml(last.icon || '🎉')} Meta alcanzada: ${escapeHtml(last.text || 'recompensa')}`;
    }
    if (Number(cart.total_discount) > 0) message = `🎉 Descuento aplicado automáticamente · Ahorras ${money(cart.total_discount)}`;
    qsa('[data-cart-progress-message]').forEach(el => el.innerHTML = message);

    qsa('[data-free-shipping-status]').forEach(el => {
      if (!cfg.freeShippingEnabled || freeGoal <= 0) { el.innerHTML = ''; return; }
      if (spend >= freeGoal) {
        el.innerHTML = `<strong>🚚 Envío GRATIS conseguido ✓</strong><br><small>Se mantiene junto con tus descuentos. Se confirma según dirección y reglas activas en checkout.</small>`;
      } else {
        el.innerHTML = `Te faltan <strong>${money(freeGoal - spend)}</strong> para conseguir envío gratis.`;
      }
    });
  }

  function updateCartTotals(cart) {
    qsa('[data-cart-subtotal]').forEach(el => el.textContent = money(cart.items_subtotal_price));
    qsa('[data-cart-total]').forEach(el => el.textContent = money(cart.total_price));
    qsa('[data-cart-discount]').forEach(el => el.textContent = `-${money(cart.total_discount)}`);
    qsa('[data-cart-savings-value]').forEach(el => el.textContent = money(cart.total_discount));
    qsa('[data-cart-discount-row],[data-cart-savings]').forEach(el => el.toggleAttribute('hidden', !(Number(cart.total_discount) > 0)));
  }

  function renderDrawer(cart) {
    const list = qs('[data-cart-items]');
    if (list) list.innerHTML = cart.items.map(cartLineMarkup).join('');
    qs('[data-cart-empty]')?.toggleAttribute('hidden', cart.item_count > 0);
    qs('[data-cart-footer]')?.toggleAttribute('hidden', cart.item_count === 0);
  }

  function updateCartUI(cart) {
    updateCartCount(cart);
    renderDrawer(cart);
    updateCartTotals(cart);
    updateRewards(cart);
    updateServiceCards(cart);
  }

  async function refreshMainCartSection() {
    const current = qs('[data-main-cart]');
    if (!current) return;
    const sectionId = current.dataset.sectionId;
    if (!sectionId) return;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    const response = await fetch(url.toString(), { headers: { 'Accept': 'text/html' } });
    if (!response.ok) throw new Error('No se pudo refrescar la sección del carrito');
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const replacement = qs('[data-main-cart]', doc);
    if (replacement) current.replaceWith(replacement);
  }

  async function refreshAfterMutation(cart = null) {
    let state = cart;
    if (!state) state = await getCart();
    updateCartUI(state);
    try { await refreshMainCartSection(); } catch (err) { console.warn('AP Store: carrito actualizado, pero la vista completa no pudo refrescarse.', err); }
    return state;
  }

  async function addVariant(variantId, quantity = 1, properties = null, openDrawer = true) {
    const item = { id: Number(variantId), quantity: Math.max(1, Number(quantity) || 1) };
    if (properties) item.properties = properties;
    await cartAdd([item]);
    toast(cfg.strings?.added || '✓ Añadido');
    if (openDrawer) openCartDrawer();
    try { await refreshAfterMutation(); }
    catch (uiError) { console.warn('AP Store: producto añadido correctamente, pero falló el refresco visual.', uiError); }
  }

  async function buyVariant(variantId, quantity = 1) {
    await cartAdd([{ id: Number(variantId), quantity: Math.max(1, Number(quantity) || 1) }]);
    window.location.assign(cfg.checkoutUrl || '/checkout');
  }

  function handleButtonFeedback(button) {
    if (!button) return;
    const original = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '✓ Añadido';
    setTimeout(() => { button.disabled = false; button.innerHTML = original; }, 1200);
  }

  function initProductSection(section) {
    if (!section || section.dataset.productInitialized) return;
    section.dataset.productInitialized = 'true';
    const jsonEl = qs('[data-product-json]', section);
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    const form = qs('form[action*="/cart/add"]', section);
    const idInput = qs('[data-variant-id-input]', section);
    const qtyInput = form?.querySelector('input[name="quantity"]');
    const groups = qsa('[data-option-group]', section);
    const addButton = qs('[data-product-add]', section);
    const buyButton = qs('[data-product-buy]', section);
    let currentVariant = product.variants.find(v => String(v.id) === String(idInput?.value)) || product.variants[0];

    function showMedia(mediaId) {
      const media = qsa('[data-product-media]', section);
      const thumbs = qsa('[data-gallery-thumb]', section);
      let index = media.findIndex(m => String(m.dataset.mediaId) === String(mediaId));
      if (index < 0) index = 0;
      media.forEach((m, i) => { m.classList.toggle('is-active', i === index); m.toggleAttribute('hidden', i !== index); });
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      const counter = qs('[data-gallery-counter]', section);
      if (counter) counter.textContent = `${index + 1}/${media.length}`;
      qs('[data-product-stage]', section)?.setAttribute('data-current-index', String(index));
    }

    function selectedOptions() {
      return groups.map(group => qs('.variant-value.is-selected', group)?.dataset.optionValue || '');
    }

    function findVariant() {
      const selected = selectedOptions();
      return product.variants.find(v => (v.options || []).every((value, i) => String(value) === String(selected[i])));
    }

    function updateVariant(variant) {
      if (!variant) {
        addButton && (addButton.disabled = true);
        buyButton && (buyButton.disabled = true);
        const stock = qs('[data-product-stock]', section);
        if (stock) { stock.textContent = 'Combinación no disponible'; stock.classList.add('is-soldout'); }
        return;
      }
      currentVariant = variant;
      if (idInput) idInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (buyButton) buyButton.disabled = !variant.available;
      const addText = qs('[data-product-add-text]', section);
      if (addText) addText.textContent = variant.available ? (section.dataset.addLabel || 'Añadir al carrito') : 'Agotado';
      const stock = qs('[data-product-stock]', section);
      if (stock) {
        stock.textContent = variant.available ? `● En stock · ${section.dataset.stockText || 'Disponible'}` : 'Agotado';
        stock.classList.toggle('is-soldout', !variant.available);
      }
      const price = qs('[data-product-price]', section);
      const compare = qs('[data-product-compare]', section);
      const discount = qs('[data-product-discount]', section);
      if (price) price.textContent = money(variant.price);
      if (compare) {
        const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
        compare.toggleAttribute('hidden', !hasCompare);
        compare.textContent = hasCompare ? money(variant.compare_at_price) : '';
        if (discount) {
          discount.toggleAttribute('hidden', !hasCompare);
          discount.textContent = hasCompare ? `-${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%` : '';
        }
      }
      qsa('[data-sticky-price]', section).forEach(el => el.textContent = money(variant.price));
      qsa('[data-sticky-variant-title]', section).forEach(el => el.textContent = variant.title || '');
      const mediaId = variant.featured_media?.id || variant.featured_image?.id; if (mediaId) showMedia(mediaId);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      } catch (urlError) {
        console.warn('AP Store: no se pudo actualizar la variante en la URL.', urlError);
      }
    }

    groups.forEach(group => {
      group.addEventListener('click', e => {
        const btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        qsa('[data-option-value]', group).forEach(b => { b.classList.toggle('is-selected', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        updateVariant(findVariant());
      });
    });

    qsa('[data-gallery-thumb]', section).forEach(thumb => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId)));
    qs('[data-gallery-prev]', section)?.addEventListener('click', () => {
      const media = qsa('[data-product-media]', section); if (!media.length) return;
      const index = Number(qs('[data-product-stage]', section)?.dataset.currentIndex || media.findIndex(m => m.classList.contains('is-active')) || 0);
      showMedia(media[(index - 1 + media.length) % media.length].dataset.mediaId);
    });
    qs('[data-gallery-next]', section)?.addEventListener('click', () => {
      const media = qsa('[data-product-media]', section); if (!media.length) return;
      const index = Number(qs('[data-product-stage]', section)?.dataset.currentIndex || media.findIndex(m => m.classList.contains('is-active')) || 0);
      showMedia(media[(index + 1) % media.length].dataset.mediaId);
    });

    qsa('[data-zoom-image]', section).forEach(img => {
      img.addEventListener('mouseenter', () => img.classList.add('is-zoomed'));
      img.addEventListener('mousemove', e => {
        const rect = img.getBoundingClientRect();
        const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
        const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
        img.style.setProperty('--zoom-x', `${x}%`);
        img.style.setProperty('--zoom-y', `${y}%`);
      });
      img.addEventListener('mouseleave', () => img.classList.remove('is-zoomed'));
    });

    qsa('[data-product-qty]', section).forEach(btn => btn.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + Number(btn.dataset.productQty || 0));
    }));

    addButton?.addEventListener('click', async e => {
      e.preventDefault();
      if (!currentVariant?.available || addButton.disabled) return;
      addButton.disabled = true;
      try {
        await addVariant(currentVariant.id, qtyInput?.value || 1, null, true);
        handleButtonFeedback(addButton);
      } catch (err) {
        addButton.disabled = false;
        console.warn('AP Store: no se pudo añadir el producto.', err);
        toast(cfg.strings?.addError || 'No se pudo añadir el producto');
      }
    });
    buyButton?.addEventListener('click', async () => {
      if (!currentVariant?.available) return;
      buyButton.disabled = true;
      try { await buyVariant(currentVariant.id, qtyInput?.value || 1); }
      catch (err) { buyButton.disabled = false; console.warn('AP Store: error al continuar al pago.', err); toast('No se pudo continuar al pago'); }
    });
    qs('[data-sticky-add]', section)?.addEventListener('click', () => form?.requestSubmit());
    qs('[data-sticky-buy]', section)?.addEventListener('click', () => buyButton?.click());

    const sticky = qs('[data-product-sticky-bar]', section);
    const target = qs('.product-purchase-actions', section);
    if (sticky && target && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const visible = !entries[0].isIntersecting && window.scrollY > target.offsetTop;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }, { threshold: 0.1 });
      observer.observe(target);
    }
    updateVariant(currentVariant);
  }

  function isBusinessDay(date) {
    const day = date.getDay();
    if (cfg.delivery?.excludeSaturday && day === 6) return false;
    if (cfg.delivery?.excludeSunday && day === 0) return false;
    return true;
  }
  function nextBusinessDay(date) {
    const d = new Date(date);
    do { d.setDate(d.getDate() + 1); } while (!isBusinessDay(d));
    return d;
  }
  function addBusinessDays(date, days) {
    let d = new Date(date);
    let left = Math.max(0, Number(days) || 0);
    while (left > 0) { d.setDate(d.getDate() + 1); if (isBusinessDay(d)) left--; }
    while (!isBusinessDay(d)) d = nextBusinessDay(d);
    return d;
  }
  function addCalendarDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + Math.max(0, Number(days) || 0));
    return d;
  }
  function initDelivery() {
    const cards = qsa('[data-delivery-card]');
    const inline = qsa('[data-delivery-inline]');
    if (!cards.length && !inline.length) return;
    const now = new Date();
    const businessDays = cfg.delivery?.businessDays !== false;
    const [cutH, cutM] = String(cfg.delivery?.cutoff || '14:00').split(':').map(Number);
    let base = new Date(now);
    const afterCutoff = now.getHours() > cutH || (now.getHours() === cutH && now.getMinutes() >= cutM);

    if (businessDays) {
      if (afterCutoff || !isBusinessDay(base)) base = nextBusinessDay(base);
    } else if (afterCutoff) {
      base = addCalendarDays(base, 1);
    }

    const addDays = businessDays ? addBusinessDays : addCalendarDays;
    const prepDays = Number(cfg.delivery?.prepDays || 0);
    const transitMin = Number(cfg.delivery?.transitMin || 1);
    const transitMax = Math.max(transitMin, Number(cfg.delivery?.transitMax || 2));
    const prep = addDays(base, prepDays);
    const min = addDays(prep, transitMin);
    const max = addDays(prep, transitMax);
    const fmtShort = d => new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short' }).format(d);
    const fmtLong = d => new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).format(d);
    const orderText = afterCutoff ? (businessDays ? 'Próx. día hábil' : 'Mañana') : 'Hoy';
    const deliveryRange = fmtShort(min) === fmtShort(max) ? fmtShort(min) : `${fmtShort(min)} – ${fmtShort(max)}`;
    const dayLabel = businessDays ? 'días hábiles' : 'días';
    const transitText = transitMin === transitMax ? `${transitMin} ${transitMin === 1 ? (businessDays ? 'día hábil' : 'día') : dayLabel}` : `${transitMin}-${transitMax} ${dayLabel}`;
    qsa('[data-delivery-order]').forEach(el => el.textContent = orderText);
    qsa('[data-delivery-prep]').forEach(el => el.textContent = fmtShort(prep));
    qsa('[data-delivery-transit]').forEach(el => el.textContent = transitText);
    qsa('[data-delivery-range]').forEach(el => el.textContent = deliveryRange);
    qsa('[data-delivery-title-range]').forEach(el => el.textContent = deliveryRange);
    qsa('[data-delivery-inline-text]').forEach(el => el.textContent = `Pídelo hoy y recíbelo aprox. entre ${fmtLong(min)} y ${fmtLong(max)}`);
  }

  function initHeroSliders() {
    qsa('[data-hero-slider]').forEach(slider => {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';
      const slides = qsa('[data-hero-slide]', slider);
      const dots = qsa('[data-hero-dot]', slider);
      if (slides.length < 2) return;
      let index = 0, timer;
      const show = i => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
      };
      qs('[data-hero-prev]', slider)?.addEventListener('click', () => show(index - 1));
      qs('[data-hero-next]', slider)?.addEventListener('click', () => show(index + 1));
      dots.forEach(d => d.addEventListener('click', () => show(Number(d.dataset.heroDot))));
      if (slider.dataset.autoplay === 'true' && !reducedMotion) {
        const interval = Number(slider.dataset.interval || 6000);
        timer = setInterval(() => show(index + 1), interval);
        slider.addEventListener('mouseenter', () => clearInterval(timer));
      }
    });
  }

  function initAnnouncements() {
    qsa('[data-announcement-rotator]').forEach(rotator => {
      const items = qsa('.announcement-bar__message', rotator);
      if (!items.length) return;
      let i = 0;
      items.forEach((item, index) => item.classList.toggle('is-active', index === 0));
      if (items.length < 2 || reducedMotion) return;
      const interval = Math.max(3000, Number(rotator.dataset.interval || 3000));
      let timer = setInterval(nextMessage, interval);
      function nextMessage(){
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }
      rotator.addEventListener('mouseenter', () => clearInterval(timer));
      rotator.addEventListener('mouseleave', () => { clearInterval(timer); timer = setInterval(nextMessage, interval); });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) clearInterval(timer);
        else { clearInterval(timer); timer = setInterval(nextMessage, interval); }
      });
    });
    qsa('[data-countdown]').forEach(el => {
      const end = new Date(el.dataset.end);
      if (Number.isNaN(end.getTime())) return;
      const out = qs('[data-countdown-value]', el);
      const tick = () => {
        const diff = Math.max(0, end.getTime() - Date.now());
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const mins = Math.floor((diff % 3600000) / 60000);
        const secs = Math.floor((diff % 60000) / 1000);
        if (out) out.textContent = `${String(days).padStart(2,'0')} DÍAS · ${String(hours).padStart(2,'0')} H · ${String(mins).padStart(2,'0')} M · ${String(secs).padStart(2,'0')} S`;
      };
      tick(); setInterval(tick, 1000);
    });
  }

  async function initRecommendations() {
    qsa('.js-product-recommendations').forEach(section => {
      if (section.dataset.loaded) return;
      section.dataset.loaded = 'true';
      const load = async () => {
        try {
          const response = await fetch(section.dataset.recommendationsUrl, { headers: { 'Accept': 'text/html' } });
          if (!response.ok) return;
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const next = qs('.js-product-recommendations', doc);
          if (next && next.innerHTML.trim()) section.replaceWith(next);
        } catch (e) { console.warn('AP Store: recomendaciones no disponibles.', e); }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) { observer.disconnect(); load(); } }, { rootMargin: '300px 0px' });
        observer.observe(section);
      } else load();
    });
  }

  function initCtaAttention() {
    if (reducedMotion) return;
    const interval = Math.max(6000, Number(cfg.pulseInterval || 12000));
    setInterval(() => {
      qsa('[data-cta-attention]:not([disabled])').forEach((button, i) => {
        setTimeout(() => { button.classList.add('is-attention'); setTimeout(() => button.classList.remove('is-attention'), 750); }, i * 90);
      });
    }, interval);
  }

  document.addEventListener('click', async e => {
    const openCart = e.target.closest('[data-cart-open]');
    if (openCart) { e.preventDefault(); closeMobileMenu(); openCartDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-drawer-overlay]')) { closeCartDrawer(); return; }
    if (e.target.closest('[data-mobile-menu-open]')) { openMobileMenu(); return; }
    if (e.target.closest('[data-mobile-menu-close]') || e.target.closest('[data-mobile-menu-overlay]')) { closeMobileMenu(); return; }

    const add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      try { await addVariant(add.dataset.variantId, 1, null, true); handleButtonFeedback(add); }
      catch (err) { console.warn('AP Store: error al añadir.', err); toast(cfg.strings?.addError || 'No se pudo añadir el producto'); }
      return;
    }
    const buy = e.target.closest('[data-buy-card]');
    if (buy) {
      e.preventDefault(); buy.disabled = true;
      try { await buyVariant(buy.dataset.variantId, 1); }
      catch (err) { buy.disabled = false; console.warn('AP Store: error al continuar al pago.', err); toast('No se pudo continuar al pago'); }
      return;
    }
    const quickOpen = e.target.closest('[data-open-quick-selector]');
    if (quickOpen) {
      e.preventDefault();
      const dialog = qs('[data-quick-selector]', quickOpen.closest('[data-product-card]'));
      if (dialog) { dialog.dataset.action = quickOpen.dataset.quickAction === 'buy' ? 'buy' : 'add'; dialog.showModal(); }
      return;
    }
    const quickVariant = e.target.closest('[data-quick-variant-id]');
    if (quickVariant) {
      e.preventDefault();
      const dialog = quickVariant.closest('[data-quick-selector]');
      const action = dialog?.dataset.action || 'add';
      try {
        if (action === 'buy') await buyVariant(quickVariant.dataset.quickVariantId, 1);
        else { await addVariant(quickVariant.dataset.quickVariantId, 1, null, true); dialog?.close(); }
      } catch (err) { console.warn('AP Store: error al añadir.', err); toast(cfg.strings?.addError || 'No se pudo añadir el producto'); }
      return;
    }

    const qty = e.target.closest('[data-qty-change]');
    if (qty) {
      e.preventDefault();
      // El botón también tiene data-line-key, por eso no debemos usar
      // closest('[data-line-key]'): devolvería el propio botón y la cantidad
      // se leería como 0. Buscamos la fila real del carrito.
      const line = qty.closest('.cart-line, .main-cart-line');
      const current = Number(qs('[data-line-qty]', line)?.textContent || 0);
      const delta = Number(qty.dataset.qtyChange || 0);
      const next = Math.max(0, current + delta);
      qty.disabled = true;
      try {
        const cart = await cartChange(qty.dataset.lineKey, next);
        updateCartUI(cart);
        await refreshMainCartSection().catch(err => console.warn(err));
        if (next > 0) toast(`Cantidad actualizada: ${next}`);
      }
      catch (err) { toast('No se pudo actualizar la cantidad'); }
      finally { qty.disabled = false; }
      return;
    }
    const remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault(); remove.disabled = true;
      try { const cart = await cartChange(remove.dataset.lineKey, 0); updateCartUI(cart); await refreshMainCartSection().catch(err => console.warn(err)); }
      catch (err) { toast('No se pudo eliminar el producto'); }
      finally { remove.disabled = false; }
      return;
    }
    const service = e.target.closest('[data-service-toggle]');
    if (service) {
      e.preventDefault();
      const card = service.closest('[data-service-card]');
      service.disabled = true;
      try {
        const key = card.dataset.serviceKey;
        let cart;
        if (key) cart = await cartChange(key, 0);
        else {
          await cartAdd([{ id: Number(card.dataset.serviceVariant), quantity: 1, properties: { _ap_service: 'true' } }]);
          cart = await getCart();
          openCartDrawer();
          toast('✓ Servicio adicional activado');
        }
        updateCartUI(cart);
        await refreshMainCartSection().catch(err => console.warn(err));
      } catch (err) { toast('No se pudo activar o desactivar el servicio'); }
      finally { service.disabled = false; }
      return;
    }
  });

  document.addEventListener('change', e => {
    const select = e.target.closest('[data-auto-submit]');
    if (select) select.form?.submit();
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeCartDrawer(); closeMobileMenu(); return; }
    if (e.key !== 'Tab') return;
    const container = qs('[data-cart-drawer].is-open') || qs('[data-mobile-menu].is-open');
    if (!container) return;
    const focusable = qsa('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', container).filter(el => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function initAll() {
    initHeroSliders();
    initAnnouncements();
    qsa('[data-product-section]').forEach(initProductSection);
    initDelivery();
    initRecommendations();
    initCtaAttention();
    getCart().then(updateCartUI).catch(err => console.warn('AP Store: no se pudo inicializar el carrito.', err));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', event => {
    initHeroSliders();
    initAnnouncements();
    qsa('[data-product-section]', event.target).forEach(initProductSection);
    initDelivery();
    initRecommendations();
  });
})();
